module.exports = __webpack_public_path__ + "static/media/primary-dark.6c43d2d3.svg";